<div class="container">
  @if (header) {
    <div class="row py-1">
      <div class="col-12 row-heading d-flex justify-content-between">
        @if (header != 'HOT FLAG') {
          <div class="col-12 row-heading d-flex justify-content-between">
            <span>{{header}}</span>
            @if (headerRight) {
              <span>{{headerRight}}</span>
            }
          </div>
        }
        @if (header == 'HOT FLAG') {
          <div class="col-12 row-heading d-flex justify-content-between">
            <span>{{header}}</span>
            @if (notHotFlag95And99) {
              <span>* Requisition will be created automatically for these items.</span>
            }
          </div>
        }
      </div>
    </div>
  }
  <order-item-header
    [showCouponColumn]="showCouponColumn" [showHotFlagColumn]="showHotFlagColumn">
  </order-item-header>
  @for (orderItem of orderItems; track orderItem; let i = $index) {
    <order-item
      [orderItem]="orderItem"
      [idSuffix]="idSuffix"
      [index]="i"
      [showCouponColumn]="showCouponColumn"
      [couponValue]="orderItemCouponValues[orderItem.id] || 0"
      [displayAllHotFlags]="displayAllHotFlags"
      >
    </order-item>
  }
</div>
